import React from 'react'
import TieupRow from '../TieupRow'
import TreadleNumbersRow from '../TreadleNumbersRow'

class TieupGrid extends React.Component {

    createTieupRow(rowNumber) {
        let tieupRowDataArray = this.props.tieupDataArray[rowNumber]
        let newToggleRowCellFunction = null

        if (this.props.toggleGridCellFunction) {
            newToggleRowCellFunction = (cell) => { return this.props.toggleGridCellFunction(rowNumber, cell) }
        }
        
        let tieupRow =
            <TieupRow
                key={rowNumber}
                cellsData={tieupRowDataArray}
                cellsCount={this.props.treadlesCount}
                toggleRowCellFunction={newToggleRowCellFunction}
                shaftDisplayNumber = { this.props.shaftsCount - rowNumber }
            />

        return tieupRow
    }

    createTieupRows() {
        let rowsArray = []
        for (let s = 0; s < this.props.shaftsCount; s++) {
            rowsArray.push(this.createTieupRow(s))
        }
        rowsArray.push(
            <TreadleNumbersRow key='numbersDisplayRow' cellsCount = { this.props.treadlesCount } />
        )
        return rowsArray
    }

    render() {
        let tieupGridContainer =
            <div className='reducer-small-padding-top'>
                <div className='reducer-tieup-grid'>
                    {this.createTieupRows()}
                </div>
            </div>
        return tieupGridContainer
    }

}

export default TieupGrid


// WEBPACK FOOTER //
// ./src/scenes/reducer/components/TieupGrid/index.js